import React, { useMemo, useState } from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { cn } from '@/lib/utils';

// Preenche lacunas tocando em palavras de um banco (sem digitação — mobile-first).
// sentence: texto com marcadores {0}, {1}... na ordem das lacunas.
// blanks: resposta certa de cada marcador, na mesma ordem.
// wordBank: todas as opções tocáveis (certas + distratoras), já embaralhadas pelo autor do conteúdo.
export function FillInTheBlank({ sentence, blanks, wordBank }) {
  const [filled, setFilled] = useState(() => new Array(blanks.length).fill(null));
  const [usedWords, setUsedWords] = useState({});
  const [shakeWord, setShakeWord] = useState(null);

  const firstEmptyIndex = filled.findIndex(w => w === null);
  const done = firstEmptyIndex === -1;

  const handleWordTap = word => {
    if (done || usedWords[word]) return;
    if (word === blanks[firstEmptyIndex]) {
      setFilled(prev => prev.map((w, i) => (i === firstEmptyIndex ? word : w)));
      setUsedWords(prev => ({ ...prev, [word]: true }));
    } else {
      setShakeWord(word);
      setTimeout(() => setShakeWord(null), 500);
    }
  };

  const parts = useMemo(() => sentence.split(/(\{\d+\})/g), [sentence]);

  return (
    <div className="flex flex-col gap-5 rounded-2xl border border-solid border-neutral-100 bg-white p-6 shadow-card">
      <p className="text-lg leading-loose text-primary-dark">
        {parts.map((part, i) => {
          const match = part.match(/^\{(\d+)\}$/);
          if (!match) return <React.Fragment key={i}>{part}</React.Fragment>;
          const idx = Number(match[1]);
          const word = filled[idx];
          return (
            <span
              key={i}
              className={cn(
                'mx-1 inline-block min-w-[90px] rounded-lg border-b-2 px-2 py-0.5 text-center align-middle font-bold',
                word ? 'border-success bg-success-lightest text-success' : 'border-dashed border-neutral-light bg-bright text-transparent'
              )}
            >
              {word || '···'}
            </span>
          );
        })}
      </p>

      {!done ? (
        <div className="flex flex-wrap gap-2">
          {wordBank.map(word => (
            <button
              key={word}
              type="button"
              disabled={usedWords[word]}
              onClick={() => handleWordTap(word)}
              className={cn(
                'rounded-full border-2 border-solid border-neutral-lightest bg-white px-4 py-2 text-sm font-bold text-primary-dark shadow-dropshadow-sm transition-colors',
                'disabled:cursor-default disabled:border-success disabled:bg-success-lightest disabled:text-success disabled:opacity-60',
                shakeWord === word && 'border-rose-400 bg-rose-50 text-rose-500'
              )}
            >
              {word}
            </button>
          ))}
        </div>
      ) : (
        <div className="flex items-center gap-2 rounded-xl bg-success-lightest px-4 py-3 font-bold text-success">
          <FiCheckCircle className="h-5 w-5 shrink-0" />
          Muito bem! Frase completa corretamente.
        </div>
      )}
    </div>
  );
}

export default FillInTheBlank;
